var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeCollectionSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeCollection_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,22.05l-4.19-1.39a3.55,3.55,0,0,0-1.78-.6l-6-2-.8.27A7,7,0,0,0,5,18c-1.66,0-3,.45-3,1s.78.78,1.89.93H4l.4,0L5,20c1.66,0,3-.45,3-1v2c0,.55-1.34,1-3,1s-3-.45-3-1v-.93l-2,.67v6.59L11,31l21-7V18.05ZM16,23c0,.55-1.34,1-3,1s-3-.45-3-1V21c0,.55,1.34,1,3,1s3-.45,3-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.11,7h.13c.24,0,.49,0,.76,0s.48,0,.72,0l.17,0,.52-.07.12,0a3.79,3.79,0,0,0,1-.34h0c.28-.15.45-.33.45-.52,0-.55-1.34-1-3-1s-3,.45-3,1S16.89,6.82,18.11,7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,9.33V10c0,.55-1.34,1-3,1s-3-.45-3-1V8c0,.55,1.34,1,3,1s3-.45,3-1-1.34-1-3-1a5.7,5.7,0,0,0-2.55.48L22,6.67V8c0,.55-1.34,1-3,1s-3-.45-3-1V7.33l-1.14.38A4.46,4.46,0,0,0,12,7c-1.66,0-3,.45-3,1s.89.82,2.11.95h.13c.24,0,.49,0,.76,0s.48,0,.72,0l.17,0,.52-.07.12,0a3.79,3.79,0,0,0,1-.34h0c.28-.15.45-.33.45-.52A.33.33,0,0,0,15,7.84.33.33,0,0,1,15,8v2c0,.55-1.34,1-3,1s-3-.45-3-1V9.67L8,10v6l12,4,12-4V10ZM23,12c0,.55-1.34,1-3,1s-3-.45-3-1V10c0,.55,1.34,1,3,1s3-.45,3-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCollectionSvg);
export default __webpack_public_path__ + "static/media/HomeCollection_svg.a177a287589e3f75661d698650ad92b9.svg";
export { ForwardRef as ReactComponent };